import { ModalForm } from 'framework/form';
import { Modal } from 'framework/ui/ui-builder';
import useEngineeringService from '../useEngineeringService';
import { EngineeringBugReport, SaveBugPayload } from '../types';
import { modalActionsSx } from '../shared/modalActionsSx';
import BugForm from './BugForm';
import { bugValidation } from './bugValidation';

interface CreateBugModalProps {
  projectId: string;
  isOpen: boolean;
  onClose: () => void;
  onSaved: (bug: EngineeringBugReport) => void;
}

const CreateBugModal = ({ projectId, isOpen, onClose, onSaved }: CreateBugModalProps) => {
  const { createBug } = useEngineeringService();

  return (
    <Modal isOpen={isOpen} onToggle={onClose} title="Add bug">
      <ModalForm
        modalOpen={isOpen}
        closeModal={onClose}
        submitButtonText="Add bug"
        actionsSx={modalActionsSx}
        submitFormFunc={async values => {
          const { shortDescription, isCritical, linkToDetails, notes } = values;
          const payload: SaveBugPayload = {
            shortDescription,
            isCritical: isCritical === 'true',
            linkToDetails: linkToDetails || null,
            notes: notes || '',
          };
          return { result: await createBug(projectId, payload) };
        }}
        afterSubmit={{
          message: 'You are awesome! Bug has been successfully created.',
          execute: (response: { result: EngineeringBugReport }) => onSaved(response.result),
        }}
        getValidationSchemaFunc={() => Promise.resolve(bugValidation)}
      >
        <BugForm />
      </ModalForm>
    </Modal>
  );
};

export default CreateBugModal;
